<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-attendance-analysis`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 27a8 8 0 017.125 11.642l3.296 3.296a1 1 0 010 1.414l-1.697 1.697a1 1 0 01-1.414 0l-3.19-3.19A8 8 0 1135 27zM15 4a1 1 0 011 1v1h16V5a1 1 0 011-1h2a1 1 0 011 1v1h6c1.105 0 2 .945 2 2.111V24H8v16h16v4H6c-1.105 0-2-.945-2-2.111V8.11C4 6.945 4.895 6 6 6h5.999L12 5a1 1 0 011-1h2zm20 27a4 4 0 100 8 4 4 0 000-8zM11.999 10H8v10h32V10h-4v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H16v1a1 1 0 01-1 1h-2a1 1 0 01-1-1l-.001-1z"/></svg>
</template>
<script>

export default {
  name: 'IconAttendanceAnalysis',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
